import React, { useEffect, useRef } from 'react';
import Input from '@/components/General/inputs/Input';

/**
 * Renders `phone` schema fields (US). Uses the shared `Input` with a tel
 * keyboard type. US phone format validation + normalization runs in `FormView`
 * (client-side) and the submit edge function.
 *
 * Autofill: when `field.config.autofillLoggedIn` is true and a `loggedInUser`
 * is provided, the field pre-fills with the first available phone number once
 * on mount if empty.
 */
const PhoneField = ({ field, value, onChange, disabled, loggedInUser }) => {
    const didAutofill = useRef(false);
    const config = field.config || {};

    useEffect(() => {
        if (didAutofill.current) return;
        if (disabled || typeof onChange !== 'function') return;
        if (config.autofillLoggedIn === false || !loggedInUser) return;
        if (value) return;

        const phone =
            loggedInUser.Phones?.[0]?.phoneNumber ??
            (Array.isArray(loggedInUser.phone) ? loggedInUser.phone[0] : loggedInUser.phone) ??
            '';

        didAutofill.current = true;
        onChange(phone);
    }, [config.autofillLoggedIn, loggedInUser, value, onChange]);

    return (
        <Input
            testID={`form-field-${field.fieldId}`}
            title={field.label}
            placeholder={field.placeholder}
            value={value ?? ''}
            onUpdate={onChange}
            type="tel"
            required={field.required}
            helpText={field.description}
            disabled={disabled}
            autoCapitalize="none"
            autoComplete="tel"
        />
    );
};

export default PhoneField;
